export default {
  "content": "<title>Umbrella</title><path d=\"M256 272v160a32 32 0 01-32 32 32 32 0 01-32-32m272-160c0-114.88-93.12-208-208-208S48 157.12 48 272a67.88 67.88 0 0196 0 78.28 78.28 0 01102.31-7.27L256 272l9.69-7.27A78.28 78.28 0 01368 272a67.88 67.88 0 0196 0zM256 64V48\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};